// src/firebase.js
import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getFunctions, httpsCallable } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyArlATs9-iJVRymgj4q47Bq6ne5IsSG5kE",
  authDomain: "quoter-d032a.firebaseapp.com",
  projectId: "quoter-d032a",
  storageBucket: "quoter-d032a.firebasestorage.app",
  messagingSenderId: "758964124954",
  appId: "1:758964124954:web:9831ba1b7229b07e5780a3",
  measurementId: "G-3GN8502369"
};

const app = initializeApp(firebaseConfig);

// App Check must be initialized before any Firebase service calls.
// Requires REACT_APP_RECAPTCHA_SITE_KEY (reCAPTCHA v3 site key from Firebase Console > App Check).
// For localhost dev: FIREBASE_APPCHECK_DEBUG_TOKEN is set in index.js (token registered in Firebase Console).
let appCheck = null;
const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
if (recaptchaSiteKey) {
  appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(recaptchaSiteKey),
    isTokenAutoRefreshEnabled: true
  });
} else if (process.env.NODE_ENV === 'production') {
  console.warn('App Check not initialized: REACT_APP_RECAPTCHA_SITE_KEY is not set. Add it to fix callable token warnings.');
}

const db = getFirestore(app);
const auth = getAuth(app);
const functions = getFunctions(app);

export { db, auth, functions, httpsCallable, app, appCheck };